export default __webpack_public_path__ + "static/media/white_cross.26d4e5be.svg";